module.exports = __webpack_public_path__ + "zeb-d5f8526eda1e3d8608435a6f3d819fe0.jpg";